import * as React from 'react';

import FavoriteIcon from '@mui/icons-material/Favorite';

import type { HighestForecast } from '../../../output/models';

import { ChartPtsLinks } from '../../../components/ServiceLink';

import { color, format, per, percent, stockPath, textRed, ytd } from '../../../utils';

interface Props {
  highestForecast: HighestForecast;
  date?: string;
}

export const HighestForecastRow: React.FC<Props> = ({ highestForecast, date }) => {
  return (
    <tr>
      <td className={`whitespace-nowrap p-2 text-center ${date ? 'border-t' : ''}`}>{date}</td>
      <td className="border-b p-2 text-center">
        <a href={highestForecast.pdf} target="_blank">
          {highestForecast.type}
        </a>
      </td>
      <td className="border-b p-2 text-center">
        <a href={stockPath(highestForecast.code)} target="_blank">
          {highestForecast.code}
        </a>
      </td>
      <td className="border-b p-2">
        <div className="flex justify-between">
          <div className="h-[17.14px] overflow-hidden">{highestForecast.stock}</div>
          <div className="flex items-center gap-1.5">
            {highestForecast.fav ? (
              <FavoriteIcon htmlColor={color('red', 'pink')} sx={{ width: 10, height: 10 }} />
            ) : (
              <></>
            )}
            <ChartPtsLinks code={highestForecast.code} />
          </div>
        </div>
      </td>
      <td className="whitespace-nowrap border-b border-l p-2 text-right">
        {per(highestForecast, true)}
      </td>
      <td className="border-b border-l p-2 text-right">
        {format(highestForecast.forecast_net_sales) ?? '-'}
      </td>
      <td
        className={`border-b p-2 text-right ${textRed(highestForecast.forecast_ordinary_income)}`}
      >
        {format(highestForecast.forecast_ordinary_income)}
      </td>
      <td className={`border-b p-2 text-right ${textRed(highestForecast.forecast_net_income)}`}>
        {format(highestForecast.forecast_net_income)}
      </td>
      <td
        className={`border-b border-l p-2 text-right ${textRed(
          highestForecast.change_in_forecast_net_sales,
        )}`}
      >
        {percent(highestForecast.change_in_forecast_net_sales) ?? '-'}
      </td>
      <td
        className={`border-b p-2 text-right ${textRed(
          highestForecast.change_in_forecast_ordinary_income,
        )}`}
      >
        {percent(highestForecast.change_in_forecast_ordinary_income)}
      </td>
      <td
        className={`border-b p-2 text-right ${textRed(
          highestForecast.change_in_forecast_net_income,
        )}`}
      >
        {percent(highestForecast.change_in_forecast_net_income)}
      </td>
      <td className={`border-b border-l p-2 text-right ${textRed(highestForecast.ytd)}`}>
        {ytd(highestForecast)}
      </td>
    </tr>
  );
};
